import { MODULE_TYPE, STACK_TYPE } from "views/shared/constants";

import { EnvironmentType } from "./types";

export const ENVIRONMENT_QUERY: Record<EnvironmentType, string> = {
  [MODULE_TYPE]: "GetModuleEnvironment",
  [STACK_TYPE]: "GetEnvironment",
};
